<template>
  <section class="error-page">
    <div class="title-wrapper">
      <h1>403 | Access Denied</h1>
    </div>
    <div class="content">
      <div class="description-wrapper">
        <p>
          アクセスが拒否されました。<br />
          <br />
          本サイトは、複数タブ及び、複数端末でご利用する事はできません。<br />
          お手数ですがブラウザを再起動し再度アクセスを行ってください。
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AccessDenied",
  mounted() {
    this.$store.commit("loading/setLoading", false)

    // 本画面への遷移後にsocket通信が継続されていた場合、socket通信をdisconnectする
    const $socket = this.$socket.connection
    if (!_.isEmpty($socket) && $socket.connected) {
      $socket.disconnect()
    }
  }
}
</script>
